import React from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Typography,
    Button,
    Card,
    CardMedia,
    CardContent,
    CardActions,
} from '@mui/material';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';

interface Props {
    name: string;
    media: string;
    summary: string;
    to: string;
    disabled?: boolean;
}

const SectionCard: React.FunctionComponent<Props> = ({
    name,
    media,
    summary,
    to,
    disabled,
}) => {
    return (
        <Card sx={{ opacity: disabled ? 0.5 : 1 }}>
            <CardMedia
                component="img"
                height={250}
                image={media}
                alt={`Link to ${name} section`}
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    {name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {summary}
                </Typography>
            </CardContent>
            <CardActions>
                <Button
                    size="small"
                    color="primary"
                    component={RouterLink}
                    to={to}
                    disabled={disabled}
                >
                    <NavigateNextIcon />
                    Open
                </Button>
            </CardActions>
        </Card>
    );
};

SectionCard.displayName = 'SectionCard';
export default SectionCard;
